import { useTranslation } from 'react-i18next';

// Import styles
import { Circle, Input, Label } from './styles';

// Import types
import type { DefaultFieldType, FormFieldProps } from 'types/views/form';

// Import utilities
import { useHookFormField } from 'components/utilities';

type Props = FormFieldProps<DefaultFieldType>;

const InputRadio = (props: Props) => {
	const { t } = useTranslation();
	const { field, isDisabled } = useHookFormField(props);

	return (
		<Label>
			<Input
				type="radio"
				name={field.name}
				value={props.value}
				onChange={field.onChange}
				onBlur={field.onBlur}
				checked={field.value === props.value}
				disabled={isDisabled}
			/>

			<Circle />

			{t(props.label)}
		</Label>
	);
};

export default InputRadio;
